import { DefaultLayout } from '@/layouts';
import { CadModelAlignment } from '@/components/Analysis/CadModelAlignment';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useFetchCookies } from '@/hooks/useFetchCookies';
import Box from '@mui/material/Box';
import { PageLoader } from '@/components/shared/PageLoader';

export const CadAlignmentPage = () => {
  const cookiesFetched = useFetchCookies();

  const structureId = useGetStructureId();

  if (!structureId || structureId === '') {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout variant="analysis">
      <CadModelAlignment structureId={structureId} />
    </DefaultLayout>
  );
};
